$(document).ready(function(){
  initPage();
  popups();
});

function initPage(){
  swipers();
  nouisliders();
  autoRefresh();
  product();
  addressForm();
  cart();
  stores();
  register();
  forms();
  invoices();
  giftCard();
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
}

function swipers(){
  $('[data-swiper]').each(function(){
    var opt = {
      autoHeight: false
    };
    if($(this).attr('data-swiper-pagination') != undefined){
      opt.pagination = {
        el: ".swiper-pagination",
        draggable: true,
        dynamicBullets: true,
        clickable: true
      };
    }
    if($(this).attr('data-swiper-navigation') != undefined){
      opt.navigation = {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      };
    }
    if($(this).attr('data-swiper-scrollbar') != undefined){
      opt.scrollbar = {
        el: ".swiper-scrollbar",
        draggable: true,
        hide: true
      };
    }
    if(parseInt($(this).attr('data-swiper-autoplay')) > 0){
      opt.autoplay = {
        delay: $(this).attr('data-swiper-autoplay'),
        disableOnInteraction: false,
      };
    }
    if($(this).attr('data-swiper-autowidth') != undefined){
      opt.slidesPerView = "auto";
      opt.spaceBetween = 0;
    } else if($(this).attr('data-swiper-breakpoints') != undefined){
      var points = $(this).attr('data-swiper-breakpoints').split(',');
      opt.spaceBetween = 0;
      opt.breakpoints = {};
      $(points).each(function(){
        var els = this.split(':');
        if(els[0].localeCompare('default') == 0){
          opt.slidesPerView = els[1];
        } else {
          opt.breakpoints[els[0]] = {
            slidesPerView: els[1]
          }
        }
      });
    }
    try{
      var swiper = new Swiper(this, opt);
    } catch{
      console.log('error with swiper');
    }
  });
}

function nouisliders(){
  $('[data-uislider]').each(function(){
    var min = Number($(this).attr('data-uislider-from'));
    var max = Number($(this).attr('data-uislider-to'));
    var start = Number($(this).attr('data-uislider-min'));
    var end = Number($(this).attr('data-uislider-max'));
    var symbol = $(this).attr('data-uislider-symbol');
    var minparam = $(this).attr('data-uislider-minparam');
    var maxparam = $(this).attr('data-uislider-maxparam');

    var parent = $(this).parents('[data-uislider-parent]');
    var minvalue = $(parent).find('[data-uislider-minvalue]');
    var maxvalue = $(parent).find('[data-uislider-maxvalue]');
    var gtm = $(parent).attr('data-uislider-gtm') != undefined;

    var url = new URL(location.href);
    
    if(this.noUiSlider == undefined){
      var slider = noUiSlider.create(this, {
        start: [start, end],
        connect: true,
        'step': 500,
        range: {
          'min': min,
          'max': max
        }
      }, true);
      slider.on('update', function(values){
        $(minvalue).text(symbol+(values[0]/100).toFixed(2));
        $(maxvalue).text(symbol+(values[1]/100).toFixed(2));
      });
      if(minparam != undefined && maxparam != undefined){
        slider.on('change', function(values){
          if(values[0] != start){
            url.searchParams.set(minparam, values[0]/100);
            if(gtm){
              gtmSelectFilter('min_prize', values[0]/100, false);
            }
          }
          if(values[1] != end){
            url.searchParams.set(maxparam, values[1]/100);
            if(gtm){
              gtmSelectFilter('max_prize', values[1]/100, false);
            }
          }
          if(values[0] != start || values[1] != end){
            pageLoading();
            loadPage(url, '#main-collection');
          }
        });
      }
    }
  });
}

function autoRefresh(){
  $('[data-refresh]').off().on('click', function(e){
    e.preventDefault();
    pageLoading();
    var url = $(this).attr('href');
    var selector = $(this).attr('data-refresh');
    loadPage(url, selector);
  });
}

function loadPage(url, selector, callback){
  if(url != undefined && selector != undefined){
    $.get(url, function(data){
      var items = $(data).find(selector+' > *');
      
      if(items.length <= 0){
        var doc = document.implementation.createHTMLDocument('c');
        doc.open();
        doc.write(data);
        doc.close();
        items = $(doc).find(selector).html();
      }
  
      if($(items).length){
        $(selector).html(items);
        window.history.pushState({"html":data,"pageTitle":$(data).find('title').text()},"", url);
        if(Clerk != undefined && $(selector).find('[data-template]').length){
          Clerk('content', '[data-template]');
        }
        initPage();
        if(callback != undefined && callback != null){
          callback();
        }
        else if(selector != '#body-wrapper')
          pageLoading();
      }
    });
  }
}

function product(){
  $('[data-product-form]').each(function(){
    var form = this;
    var add = $(this).find('[data-product-add]');
    var purchase = $(this).find('[data-product-purchase]');
    var select = $(this).find('[data-product-select]');

    $(add).off().on('click', function(){
      addToCart(form, function(){
        loadPage(location.href, '#body-wrapper', function(){
          const drawer = new bootstrap.Offcanvas($('#theme-cart').get(0));
          drawer.show();
        });
      });
    });

    $(purchase).off().on('click', function(){
      addToCart(form, function(){
        location.href = '/checkout';
      });
    });

    $(select).off().on('click', function(){
      var id = $(this).attr('data-product-select');
      $(id).removeClass('d-none').addClass('d-flex');
    });

    quantityInput($(this).find('[data-quantity]'));
  });

  function addToCart(form, callback){
    pageLoading();
    var params = new FormData(form);
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: params,
      dataType: 'json',
      cache: false,
      contentType: false,
      processData: false,
      success: function (data) {
        if(window.gtmSet){
          gtmAddToCart(data, params.get('quantity'));
        }
        callback();
      },
      error: function (err) {
        console.log(err);
        Swal.fire({
          "icon": "error",
          "title": err.responseJSON.message,
          "text": err.responseJSON.description
        });
        pageLoading();
      }
    });
  }
}

function quantityInput(element, callback){
  var min = Number($(element).attr('data-quantity-min'));
  var max = Number($(element).attr('data-quantity-max'));

  var minus = $(element).find('[data-quantity-minus]');
  var plus = $(element).find('[data-quantity-plus]');
  var input = $(element).find('[data-quantity-input]');

  $(plus).off().on('click', function(e){
    e.preventDefault();
    var val = Number($(input).val());
    if((max >= 0 && val+1 <= max) || isNaN(max) || max<min){
      $(input).val(val+1);
      if(callback != undefined)
        callback();
    }
  });

  $(minus).off().on('click', function(e){
    e.preventDefault();
    var val = Number($(input).val());
    if(val-1 >= min || isNaN(min)){
      $(input).val(val-1);
      if(callback != undefined)
        callback();
    }
  });

  $(input).on('keyup', function(e){
    var val = Number($(input).val());
    if(!isNaN(val) && (val >= min || isNaN(min)) && ((max > 0 && val <= max) || isNaN(max) || max<min)){
      $(input).val(val);
      if(callback != undefined)
        callback();
    } else {
      $(input).val(1);
      if(callback != undefined)
        callback();
    }
  });
}

function pageLoading(){
  $('#loading-page').toggleClass('active');
}

function addressForm(){
  $('.address-form').each(function(){
    address(this);
  });

  function address(form){
    var province = $(form).find('[data-province-select]');
    var country = $(form).find('[data-country-select]');
    setProvince();

    $(country).on('change', setProvince);
    function setProvince(){
      try {
        var provinces = JSON.parse($(country).find('option:selected').attr('data-provinces'));
        if(provinces.length){
          var p = ['<option value=""></option>'];
          $(provinces).each(function(){
            p.push('<option value="'+this[0]+'">'+this[0]+'</option>');
          });
          $(province).html(p.join(''));
        } else {
          $(province).html("");
        }
      } catch{
        $(province).html("");
      }
    }
  }

}

function popups(){
  $('[data-popup-now]').each(function(){
    showModal(this);
  });
  $('[data-popup-delay]').each(function(){
    var delay = parseInt($(this).attr('data-popup-delay'))*1000;
    var id = this;
    setTimeout(function(){
      showModal(id);
    }, delay);
  });
  $('[data-popup-scroll]').each(function(){
    var percentage = parseInt($(this).attr('data-popup-scroll'));
    var id = this;
    $(window).on('scroll', function(){
      if(getScrollPercent() >= percentage){
        showModal(id);
        $(window).off('scroll');
      }
    })
  });
  $('[data-close-slip]').on('click', function(){
    $(this).parents('.slip-container').remove();
  });

  function showModal(el){
    var reopen = parseInt($(el).attr('data-popup-reopen'))*24*60*60*1000;
    var modal = new bootstrap.Modal(el, {});
    var canOpen = true;
    if(reopen > 0){
      var last = parseInt(window.localStorage.getItem('popup-last-close'));
      if(last > 0){
        var elapsed = Date.now() - last;
        if(elapsed < reopen){
          canOpen = false;
        }
      }
      $(el).on('hidden.bs.modal', function(){
        window.localStorage.setItem('popup-last-close', Date.now());
      });
    }
    if(canOpen)
      modal.show();
  }
}

function cart(){
  $('[data-cart-form] [data-quantity]').each(function(){
    var form = $(this).parents('form');
    var r = $(form).attr('data-cart-form');
    quantityInput(this, function(){
      pageLoading();
      $.ajax({
        type: 'POST',
        url: $(form).attr('action'),
        data: new FormData($(form).get(0)),
        dataType: 'json',
        cache: false,
        contentType: false,
        processData: false,
        success: function (data) {
          loadPage(location.href, r);
        },
        error: function (err) {
          console.log(err);
          Swal.fire({
            "icon": "error",
            "title": err.responseJSON.message,
            "text": err.responseJSON.description
          });
          pageLoading();
        }
      });
    });
  });
}

function forms(){
  $.extend($.validator.messages, form_errors);
  $('[data-validate]').each(function(){
    $(this).validate({
      highlight: function(element) {
          $(element).parents('.form-group').addClass("was-validated");
      },
      unhighlight: function(element) {
          $(element).parents('.form-group').removeClass("was-validated");
      },
      errorPlacement: function(error, element) {
        var placement = $(element).parents('.form-group').find('.invalid-feedback');
        $(placement).append(error);
      }
    });
  });

  $('[data-form-submit]').off().on('click', function(){
    var form = $(this).parents('form');
    var data = new FormData($(form).get(0));
    const isReload = $(this).attr('data-form-submit') == 'reload';
    pageLoading();
    $.ajax({
      type: $(form).attr('method'),
      url: $(form).attr('action'),
      data: data,
      dataType: 'json',
      cache: false,
      contentType: false,
      processData: false,
      success: function (d) {
        console.log(d);
        $(window).trigger('theme-form-submitted', {data: d, params: data, form: form});
        if(isReload)
          location.reload();
      },
      error: function (err) {
        console.log(err);
        Swal.fire({
          "icon": "error",
          "title": form_errors.generic
        });
        pageLoading();
      }
    });
  });

  $('[data-validate-submit]').on('click', function(){
    var form = $(this).parents('form');
    if($(form).length && $(form).valid()){
      pageLoading();
      $(form).trigger('submit');
    }
  });
}

function stores(){
  $('[data-map]').off().on('click', function(){
    var url = $(this).attr('data-map');
    $('#store-map').attr('src', url);
    $('#store-map').removeClass('inactive');
  });
}

function register(){
  $('[data-input-tag]').on('blur', function(){
    setTag($(this).parents('form'));
  });
  $('[data-input-tag]').on('change', function(){
    setTag($(this).parents('form'));
  });

  function setTag(form){
    var tags = [];
    $(form).find('[data-input-tag]').each(function(){
      var val = $(this).val();
      var tag = $(this).attr('data-input-tag')+"_"+val;
      if($(this).attr('type') == 'checkbox' && $(this).is(':checked')){
        tags.push(tag);
      } else {
        if(val != undefined && val != '' && val != null){
          tags.push(tag);
        }
      }
    });
    $('#customer-tags').val(tags.join(','));
  }
}

function invoices(){
  $('#modal-invoice [data-form-submit]').off().on('click', function(){
    pageLoading();
    var form = $(this).parents('form');
    if($(form).valid()){
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: new FormData($(form).get(0)),
        dataType: 'json',
        cache: false,
        contentType: false,
        processData: false,
        success: function (data) {
          location.reload();
        },
        error: function (err) {
          console.log(err);
          Swal.fire({
            "icon": "error",
            "title": err.responseJSON.message,
            "text": err.responseJSON.description
          });
        }
      });
    }
  });

  $('[data-invoice-remove]').off().on('click', function(){
    pageLoading();
    var data = new FormData();
    data.append('attributes[invoice]', 0);
    data.append('attributes[invoice_company]', null);
    data.append('attributes[invoice_vat]', null);
    data.append('attributes[invoice_address]', null);
    data.append('attributes[invocie_pec]', null);
    data.append('attributes[invoice_type]', null);
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      cache: false,
      contentType: false,
      processData: false,
      success: function (data) {
        location.reload();
      },
      error: function (err) {
        console.log(err);
        Swal.fire({
          "icon": "error",
          "title": err.responseJSON.message,
          "text": err.responseJSON.description
        });
      }
    });
  });
}

function getScrollPercent() {
  var h = document.documentElement, 
      b = document.body,
      st = 'scrollTop',
      sh = 'scrollHeight';
  return (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 100;
}

function giftCard(){
  if($('#qr-code').length){
    var code = $('#qr-code').attr('data-identifier');
    new QRCode( document.querySelector('#qr-code'), {
      text: code,
      width: 150,
      height: 150,
      imageAltText: 'qr'
    });
  }

  $('[data-copy]').on('click', function(){
    navigator.clipboard.writeText($(this).attr('data-copy'));
    var feed = $(this).attr('data-copy-element');
    var copied = $(this).attr('data-copy-text');
    var text = $(feed).html();
    console.log(text);
    
    $(feed).text(copied);
    setTimeout(function(){
      $(feed).html(text);
    }, 4000);
  });

  $(window).on('theme-form-submitted', function(e, data){
    var type = data.params.get('form_type');
    if(type == 'gift_card'){
      if(data.data.success){
        $(data.form).parent().find('[data-success-balance]').text('€'+data.data.balance.replaceAll('.', ','));
        $(data.form).parent().find('[data-success-box]').removeClass('d-none');
        $(data.form).find('[data-error-field]').addClass('d-none');
        $(data.form).addClass('d-none');
      } else {
        $(data.form).find('[data-error-field]').text(form_errors[data.data.error]);
        $(data.form).find('[data-error-field]').removeClass('d-none').css('display', 'block');
        $(data.form).removeClass('d-none');
      }
    }
    $('#loading-page').removeClass('active');
  });
}